import React, { useEffect, useMemo } from "react";
import { FiCheck, FiX } from "react-icons/fi";
import { useSearchParams } from "react-router-dom";
import Button from "../components/common/Button";
import PageMeta from "../components/common/PageMeta";
import { formatCurrency } from "../config/siteConfig";
import { useCommerce } from "../hooks/useCommerce";

const PaymentResultPage = () => {
  const [searchParams] = useSearchParams();
  const commerce = useCommerce();
  const succeeded = searchParams.get("state") === "success";
  const order = useMemo(() => {
    try {
      return JSON.parse(window.sessionStorage.getItem("madezuno:last-order"));
    } catch {
      return null;
    }
  }, []);

  const clearCart = commerce.clearCart;
  useEffect(() => {
    if (succeeded) clearCart();
  }, [clearCart, succeeded]);

  return (
    <div className="order-success-page">
      <PageMeta title={succeeded ? "Payment successful" : "Payment cancelled"} />
      <section className="order-success-card">
        <span className="order-success-card__icon">
          {succeeded ? <FiCheck aria-hidden="true" /> : <FiX aria-hidden="true" />}
        </span>
        <p className="eyebrow">{succeeded ? "Payment successful" : "Payment cancelled"}</p>
        <h1>{succeeded ? "Thank you for your order." : "Your payment was not completed."}</h1>
        <p>{succeeded ? "We have received your payment and will begin preparing your order." : "No completed payment was recorded. Your cart is still available so you can try again."}</p>
        {order && (
          <div className="order-success-card__summary">
            <span><small>Order number</small><strong>{order.id}</strong></span>
            <span><small>Total</small><strong>{formatCurrency(order.totals.total)}</strong></span>
            <span><small>Email</small><strong>{order.customer.email}</strong></span>
          </div>
        )}
        <div className="order-success-card__actions">
          <Button to={succeeded ? "/shop" : "/checkout"}>{succeeded ? "Continue shopping" : "Return to checkout"}</Button>
          <Button to="/" variant="secondary">Home</Button>
        </div>
      </section>
    </div>
  );
};

export default PaymentResultPage;
